<template>
  <div class="law-tag">
    <template>
      <span class="tag-status" v-if="isDraftOrInterpret && item.classification">
        {{ item.classification }}
      </span>
      <span class="tag-status" v-else-if="!isDraftOrInterpret && item.level">{{ item.level }}</span>
    </template>
    <span class="tag-status" v-if="item.publishMachinery && item.publishMachinery.length">{{
      item.publishMachinery.join('/')
    }}</span>
    <span class="tag-status" v-if="item.docNum">{{ item.docNum }}</span>
    <span class="tag-status" v-if="!isDraft && item.execTime"> 实施时间 {{ item.execTime }} </span>
    <span class="tag-status" v-if="isDraft && item.expireTime">截止时间 {{ item.expireTime }}</span>
    <span class="tag-status" v-if="item.pubTime">发布时间 {{ item.pubTime }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    item: {
      type: Object
    }
  },
  computed: {
    isDraft() {
      return ['草案'].includes(this.item.category || this.item.type);
    },
    isInterpret() {
      return ['法规解读'].includes(this.item.category || this.item.type);
    },
    isDraftOrInterpret() {
      return this.isDraft || this.isInterpret;
    }
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.law-tag {
  margin-bottom: 5px;
}
.tag-status {
  height: 20px;
  background: #f5f5f5;
  border-radius: 2px;
  display: inline-block;
  font-size: 12px;
  color: #999999;
  padding: 0 6px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/lawStatusTag.vue